// extracted by mini-css-extract-plugin
export default {"list-root":"styles_list-root__TvjqE","list-primary-text":"styles_list-primary-text__1K-iY"};